import React, { Fragment, useEffect, useState } from "react";
import "./notificationCard.css";
import { ReactComponent as YourSvg } from "./dot-svgrepo-com.svg";
import axios from "axios";
import api from "../../../utils/api";
const NotificationCard = ({ setNew }) => {
  const [newData, setNewData] = useState();

  useEffect(async () => {
    await api
      .get("/notifications")
      .then((response) => response.data)
      .then((data) => {
        const sortedData = [...data].sort((a, b) => {
          if (a.read !== b.read) return a.read ? 1 : -1;
          return b.id - a.id;
        });
        setNewData(sortedData);
      });
  }, []);

  const handleClick = (id) => {
    api
      .put(`/notifications/read`, {
        notificationIds: [id],
        read: true,
      })
      .then(async (res) => {
        await api
          .get("/notifications")
          .then((response) => response.data)
          .then((data) => {
            const sortedData = [...data].sort((a, b) => {
              if (a.read !== b.read) return a.read ? 1 : -1;
              return b.id - a.id;
            });
            setNewData(sortedData);
            setNew(sortedData);
          });
      });
  };

  useEffect(() => {
    return async () => {
      // axios.post(
      //   `${process.env.REACT_APP_BASE_URL}/notifications/`,
      //   {},
      //   {
      //     mode: "no-cors",
      //     headers: {
      //       "Content-Type": "multipart/form-data",
      //     },
      //   }
      // );
      await api.post("/notifications", {});
    };
  }, []);
  return (
    <div className="notification-card">
      {newData && newData.length > 0 ? (
        newData?.map((data) => {
          return (
            <Fragment key={data.id}>
              <p
                style={
                  data.read
                    ? { color: "gray" }
                    : { color: "black", fontWeight: "bold", cursor: "pointer" }
                }
                onClick={() => {
                  handleClick(data.id);
                }}
              >
                {" "}
                <YourSvg />
                {data.msg}
              </p>
              <hr />
            </Fragment>
          );
        })
      ) : (
        <p style={{ textAlign: "center" }}>No new notifications</p>
      )}
    </div>
  );
};

export default NotificationCard;
